module.exports = __webpack_public_path__ + "static/media/34.ba889f8e.png";